<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-radio-group class="search-radio" v-model="value">
      <el-radio-button v-for="(item,index) in searchTermList" :label="item.id" :key="index">{{item.name}}</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
  export default {
    name: "searchRadio",
    props: {
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
      searchTermList:{
        type: Array,
        default: []
      }
    },
    data: function() {
      return {
        value:this.searchValue
      }
    },
    /* computed: {
    }, */
    methods: {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchRadio.vue